export const displayText = (paymentMethod) => {
  switch (paymentMethod) {
    case "card":
      return "Cards (credit, debit, pre-paid)"
    case "us_bank_account":
      return "Bank Accounts (ACH)"
  }
}

// Returns the full class string, family included: the kit holds no bank glyph,
// so ACH comes from Classic under its canonical name (fa-bank is an alias).
export const iconClass = (paymentMethod) => {
  switch (paymentMethod) {
    case "card":
      return "fa-solid fa-credit-card"
    case "us_bank_account":
      return "fa-solid fa-building-columns"
  }
}

const ELECTRONIC_METHOD_ORDER = ["card", "us_bank_account"]

export const shortDisplayText = (paymentMethod) => {
  switch (paymentMethod) {
    case "card":
      return "card"
    case "us_bank_account":
      return "bank account"
  }
}

export const electronicMethodsLabel = (acceptedPaymentMethods) =>
  ELECTRONIC_METHOD_ORDER.filter((method) =>
    acceptedPaymentMethods.includes(method)
  )
    .map(shortDisplayText)
    .join(" or ")
